import React from 'react';
import BannerMain from '../maincomponent/Bannermain';

export default function Home() {
  return (
   <>
   <BannerMain />
   </>
  );
}
